import { withRouter } from 'react-router'
import App from './App'

export default withRouter(App)
